var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 80C501.25 80 512 69.25 512 56S501.25 32 488 32H403.094C395.594 32 388.531 35.5 384 41.453L97.031 432H24C10.75 432 0 442.75 0 456S10.75 480 24 480H108.906C116.406 480 123.469 476.5 128 470.547L414.969 80H488ZM488 432H344C330.746 432 320 442.744 320 456C320 469.254 330.746 480 344 480H488C501.254 480 512 469.254 512 456C512 442.744 501.254 432 488 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/alt.8bbd4364889159e19c6538794cbd224f.svg";
export { ForwardRef as ReactComponent };